export class Identifiers {
    public static ORCID = 'ORCID';
    public static INSI = 'INSI';
    public static ARXIV = 'arXiv';
    public static ERA = 'ERA';
    public static PIVOT = 'Pivot';
    public static PUBMED = 'Pubmed';
    public static RESEARCHER_ID = 'ResearcherID';
    public static SCOPUS = 'Scopus';
    public static WIKIDATA = 'Wikidata';
    public static VIAF = 'VIAF';
    public static GOOGLE_SCHOLAR_ID = 'GoogleScholarID';
    public static LCNAF = 'LCNAF';
}
